import React, { useState, useEffect } from 'react';
import EnhancedTextField from './EnhancedTextField';
import VideoPlayer from '../pages/catalogmanager/components/VideoPlayer';

interface EnhancedVideoFieldProps {
    value?: string;
    error?: string;
    helperText?: React.ReactNode;
    onChange?: (e: any) => void;
    style?: React.CSSProperties;
    label?: any;
    disabled?: boolean;
    [key: string]: any;
}

const EnhancedVideoField = (props: EnhancedVideoFieldProps) => {
  const [error, setError] = useState(props.error || '');
  const [showPreview, setShowPreview] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const validateVideoUrl = (url) => {
    if (!url) {
      setError('');
      setShowPreview(false);
      return true;
    }

    // Valid YouTube patterns
    const youtubePatterns = [
      /^https:\/\/(www\.)?youtube\.com\/watch\?v=[A-Za-z0-9_-]+/,
      /^https:\/\/(www\.)?youtu\.be\/[A-Za-z0-9_-]+/
    ];

    // Valid Vimeo pattern
    const vimeoPattern = /^https:\/\/vimeo\.com\/\d+/;

    const isValidYouTube = youtubePatterns.some(pattern => pattern.test(url));
    const isValidVimeo = vimeoPattern.test(url);

    if (isValidYouTube || isValidVimeo) {
      setError('');
      setShowPreview(true);
      return true;
    } else {
      setError('Please enter a valid YouTube or Vimeo URL (e.g., https://www.youtube.com/watch?v=... or https://vimeo.com/...)');
      setShowPreview(false);
      return false;
    }
  };

  useEffect(() => {
    if (props.value) {
      validateVideoUrl(props.value);
    }
  }, [props.value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    validateVideoUrl(newValue);
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    setShowPreview(false);
  };

  const handleBlur = () => {
    if (props.value) {
      validateVideoUrl(props.value);
    }
    setIsEditing(false);
  };

  return (
    <>
      {(isEditing || !showPreview || !props.value) ? (
        <EnhancedTextField
          {...props}
          style={{ width: '100%', ...props.style }}
          error={error || props.error}
          helperText={error || props.helperText || 'Enter a YouTube or Vimeo URL'}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="https://www.youtube.com/watch?v=... or https://vimeo.com/..."
          autoFocus={isEditing}
        />
      ) : null}
      {showPreview && props.value && !props.disabled && !isEditing && (
        <VideoPlayer
          url={props.value}
          label={props.label}
          onEdit={handleEdit}
        />
      )}
    </>
  );
};

export default EnhancedVideoField;
